module.exports = "https://coursera_assets.s3.amazonaws.com/images/09e8574c3d03d449d450fb5ebe294960.png";